module.exports = __webpack_public_path__ + "static/media/main_visual_compact_track_loaders_1050_rt_manitou.86c9007e.png";